module.exports = __webpack_public_path__ + "static/img/co2.04ae0f3a.svg";